import CompraModal from "./CompraModal";
export default CompraModal;